import { render, staticRenderFns } from "./BaseModalConfirm.vue?vue&type=template&id=33c2e6c4&scoped=true"
import script from "./BaseModalConfirm.vue?vue&type=script&lang=js"
export * from "./BaseModalConfirm.vue?vue&type=script&lang=js"
import style0 from "./BaseModalConfirm.vue?vue&type=style&index=0&id=33c2e6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2e6c4",
  null
  
)

export default component.exports